import { parseInt } from 'lodash-es';
import { assertMonth } from '../shared/date-types';
/**
 * converts date to ISO format YYYY-MM-DD (following HTML5 date input standard)
 * @param year year e.g. 1984
 * @param month month indexed, Jan -> 1, Feb -> 2, ...
 * @param day day of the month, indexed from 1
 */
export function dateToKey(year, month, day) {
    return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
}
/**
 * inverse of dateToKey
 * @param key should be in ISO format YYYY-MM-DD (supports legacy YYYY/MM/DD for backward compatibility)
 */
export function keyToDate(key) {
    // Support both new ISO format (YYYY-MM-DD) and legacy format (YYYY/MM/DD)
    const separator = key.includes('-') ? '-' : '/';
    const [year, month, day] = key.split(separator);
    const yearParsed = parseInt(year);
    const monthParsed = assertMonth(parseInt(month));
    const dayParsed = parseInt(day);
    if (dayParsed <= 0 || getDaysInMonth(yearParsed, monthParsed) < dayParsed) {
        console.error('day value is wrong');
    }
    return [yearParsed, monthParsed, dayParsed];
}
export function dateToSpecifiedFormat(date, formatStr) {
    const [year, month, day] = date;
    // const dateObj = new Date(year, month - 1, day); // Subtract 1 from month if using 1-12 format
    // Use the provided format string
    return formatStr
        .replace('MM', month.toString().padStart(2, '0'))
        .replace('dd', day.toString().padStart(2, '0'))
        .replace('yyyy', year.toString());
}
export function currentDateKey() {
    return dateToKey(new Date().getFullYear(), assertMonth(new Date().getMonth() + 1), new Date().getDate());
}
function getDaysInMonth(year, month) {
    // month is indexed from 1, but we take next month's 0th day
    // so here second argument is month + 1 - 1
    return new Date(year, month, 0).getDate();
}
/**
 * Parses and validates a date from any input format
 * @param value Any value that might represent a date
 * @returns The parsed date as [year, month, day] or undefined if invalid
 */
export function parseAndValidateDate(value) {
    if (value === null || value === undefined) {
        return undefined;
    }
    let dateObj;
    // Special handling for numeric strings (timestamps)
    if (typeof value === 'string' && /^\d+$/.test(value.trim())) {
        const numValue = Number(value);
        dateObj = new Date(numValue);
    }
    else {
        dateObj = new Date(value);
    }
    // Check if it's a valid date
    if (isNaN(dateObj.getTime())) {
        console.error('[DatePicker] Invalid date - could not parse:', value, typeof value);
        return undefined;
    }
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    return [year, month, day];
}
